<template>
    <div id="new-reports" class="root">
        <div class="row justify-content-center">
            <loader :loading="loading_status"></loader>
        </div>
        <div class="row">
            <div class="col-lg-12 content-body" v-if="report_data.items" v-show="!hideChart">
                <axis-chart :data="report_data"></axis-chart>
                <div class="row form-group mt-4 summary" v-if="show_summary">
                    <table class="table table-striped" v-if="!loading_status">
                        <thead class="thead-dark">
                        <tr>
                            <th v-for="item in reportItems" v-bind:data="item" v-bind:key="item"
                                scope="col" class="text-center">{{ item }}
                            </th>
                        </tr>
                        <tr>
                            <td v-for="item in reportItems" v-bind:data="item" v-bind:key="item"
                                scope="col" class="text-center">{{ getSummaryItem(item) | formatPrice }} {{ getUnit() }}
                            </td>
                        </tr>

                        </thead>
                        <tbody>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-lg-12 content-body justify-content-center" v-if="report_data.items.length <= 0">
                <h5 class="text-center text-danger pt-2">Nincs eredmény</h5>
            </div>
        </div>
    </div>
</template>

<script>

    import AxisChart from '../common/lib/charts/AxisChart'
    import Loader from '../common/controls/Loader'
    import { mapGetters, mapActions } from 'vuex'

    export default{
        name: 'Reports',
        props: ['data'],
        data(){
            return{
                show_summary: false,
                hideChart: false,
            }
        },
        components: {
            AxisChart,
            Loader
        },
        computed: {
            ...mapGetters([
                'report',
                'reportItems',
                'reportFilters',
                'loading',
                'appSettings',
            ]),
            loading_status: {
                get: function() {
                    return this.loading ? this.loading : false;
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            reportParams() {
                return this.data;
            },
            report_data: {
                get: function() {
                    return {
                        'name': this.data ? this.data.name : 'Jelentés',
                        'unit': this.getUnit(),
                        'items' : this.report,
                    }
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            report_filters: {
                get: function() {
                    return this.reportFilters;
                },
                set: function(newVal) {
                    return newVal;
                }
            },
        },
        methods: {
            ...mapActions([

            ]),
            getUnit() {
                return 'db.';
            },
            getSummaryItem(item_name) {
                let total = 0;

                if(this.report) {
                    this.report.map((item) => {

                        let keys = Object.keys(item);
                        let obj = keys.find(s => s === item_name);

                        if(item_name === obj && keys) {
                            let val = Object.values(item)[keys.indexOf(item_name)];
                            total += (val * 1);
                        }

                    })
                }

                return total
            },
        },
        mounted(){
            this.$store.commit('setReport', {});
            //lineColor = am4core.color("red")
        },
        watch: {
            report: {
                handler: function(newVal) {
                    this.report_data = newVal;
                    this.show_summary = this.reportParams.show_summary;

                    if(newVal.length > 0) {
                        this.hideChart = false;
                    } else {
                        this.hideChart = true;
                    }
                },
                deep: true,
            }
        },
    }
</script>

<style scoped="" lang="scss">
    .summary {
        overflow: hidden;
    }

    #axis-chart {
        height: 380px;
    }

    @media (max-width: 576px) {
        .summary {
            overflow: auto;
        }

        #axis-chart {
            height: 450px !important;
        }
    }

    @media (max-width: 860px) {
        #axis-chart {
            height: 480px !important;
        }
    }
</style>
